import React, { Component } from 'react'

export default elementId => WrappedComponent => {
    const el = document.getElementById(elementId)
    const model = el ? JSON.parse(decodeURIComponent(el.getAttribute('data-model'))) : []
    return class extends Component {
        render() {
            return <WrappedComponent {...this.props} model={model} />
        }
    }
}
